export const defaultToolbar = {
    // customize quickbars item => remove image on empty page
    plugins: 'print preview   importcss  code searchreplace autolink  directionality  visualblocks visualchars fullscreen image link media  codesample table charmap hr pagebreak nonbreaking  toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help   charmap   emoticons  export',
    directionality: "rtl",
    toolbar_sticky: true,
    mobile: {
        plugins: 'print preview   importcss tinydrive searchreplace autolink  directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking  toc insertdatetime advlist lists  wordcount   textpattern noneditable help   charmap quickbars  emoticons '
    },
    menu: {
        tc: {
            title: 'Comments',
            items: 'addcomment showcomments deleteallconversations'
        }
    },
    menubar: 'file edit view insert format tools table tc help',
    toolbar: 'undo redo | bold italic underline strikethrough code | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist  | forecolor backcolor   removeformat | pagebreak | charmap emoticons | fullscreen  preview print | insertfile image media  template link  codesample | a11ycheck ltr rtl | showcomments addcomment',
    autosave_ask_before_unload: true,
    autosave_retention: '2m',
    image_advtab: true,
    importcss_append: true,
    template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
    template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
    height: 600,
    image_caption: true,
    quickbars_selection_toolbar: 'bold italic | quicklink h1 h2 h3 image quicktable',
    noneditable_noneditable_class: 'mceNonEditable',
    toolbar_mode: 'sliding',
    tinycomments_mode: 'embedded',
    content_style: '.mymention{ color: blue; }',
    a11y_advanced_options: true,
    mentions_selector: '.mymention',
    mentions_item_type: 'profile',
    entity_encoding: 'raw',
    image_class_list: [
        {title: 'None', value: ''},
        {title: 'img-fluid', value: 'img-fluid'},
    ],
    style_formats: [
        {title: 'radius-5', selector: 'img', styles: {'border-radius': '5px',}},
        {title: 'radius-10', selector: 'img', styles: {'border-radius': '10px',}},
        {title: 'radius-15', selector: 'img', styles: {'border-radius': '15px',}},
    ],
}